/* eslint-disable sciencepo-rules/require-story */
/* Inutile de le tester*/
import * as mainStyles from '../../../styles/layout/main.module.scss';
import PropTypes from 'prop-types';
import FilAriane from '../../page_structure/FilAriane';
import React, { Fragment } from 'react';
import clsx from 'clsx';
import { mockInternalPageSimpleLayout } from '../../../utils/mockData';
import OpenedRelatedContents from '../../page_structure/OpenedRelatedContents';
import * as pageStyles from '../../../styles/internal-page/internal-page.module.scss';
import * as responsiveStyles from '../../../styles/responsive.module.scss';
import RelatedContent from '../../page_structure/RelatedContent';
import MarketingButton from '../../page_structure/MarketingButton';
import { useTranslation } from 'react-i18next';

const InternalPageSimpleLayoutNew = ({ children, ...props }) => {
  const propTmp = (props.mock) ? {...mockInternalPageSimpleLayout, ...props} : props;
  const {
    related_contents = [],
    bottomContent = null,
    related_column_name = ''
  } = propTmp || {};
  const [fullRelatedContents, setFullRelatedContents] = React.useState(false);
  const { t } = useTranslation();
  let displayLang = '';
  if (propTmp && propTmp.lang) {
    displayLang = propTmp.lang.toLowerCase();
  }
  if (fullRelatedContents) {
    return (
      <OpenedRelatedContents
        handleClickBack={() => setFullRelatedContents(false)}
        related_contents={ related_contents }
      />
    );
  }
  return (
    <>
      {propTmp.header?.props?.carrousel && (
        <div
          className={clsx(
            mainStyles.innerTemplateBlocHeader,
            mainStyles.innerTemplateBlocCarrousel
          )}
        >
          {propTmp.header}
        </div>
      )}
      {propTmp.header?.props?.cover && (
        <div className={mainStyles.innerTemplateBlocHeader}>
          {propTmp.header}
        </div>
      )}
      {!propTmp.header?.props?.cover && !propTmp.header?.props?.carrousel && (
        <div className={mainStyles.innerTemplateEmptyElemHeader}></div>
      )}
      <div className={mainStyles.innerTemplate}
        id="main-content-page"
      >
        <div className={mainStyles.innerTemplateFilAriane}>
          <FilAriane
            ariane={propTmp.filAriane}
            lang={displayLang}
            url={propTmp.url}
          >
          </FilAriane>
        </div>
        <div
          className={pageStyles.rootDiv}
        >
          <div
            className={
              clsx(
                pageStyles.rootItemInternalPage,
                {
                  [pageStyles.rootItemRelatedContents]: related_contents.length > 0,
                  [pageStyles.rootItemNoRelatedContents]: related_contents.length <= 0
                })
            }
          >
            {children}
          </div>
          {related_contents?.length > 0 && (
            <>
              <div className={responsiveStyles.desktop}
                style={{ minWidth: '4%' }}
              >
              </div>
              <div className={responsiveStyles.desktop}
                style={{ maxWidth: '21%' }}
              >
                <div className={pageStyles.desktopRelatedContent}>
                  {related_contents?.map((elem, index) => {
                    if (elem?.content?.length > 0) {
                      return elem.content.map((el, subIndex) => {
                        return (
                          <RelatedContent
                            elem={el}
                            key={index + '-' + subIndex}
                          />
                        );
                      });
                    } return <Fragment key={index} />;
                  })}
                </div>
              </div>
            </>
          )}
        </div>
        <div
          className={clsx(
            pageStyles.marginBetweenBlocs,
            pageStyles.desktopContent
          )}
        >
          {bottomContent}
        </div>
        {related_contents?.length > 0 && (
          <MarketingButton
            actionElement={related_contents[0]?.content[0]}
            knowMore={related_column_name || t('internal.page.more')}
            mobile
            onclick={() => {
              window.scrollTo(0, 0);
              setFullRelatedContents(true);
            }}
          />
        )}
      </div>
    </>
  );
};

InternalPageSimpleLayoutNew.propTypes = {
  children: PropTypes.node,
  filAriane: PropTypes.array.isRequired,
  header: PropTypes.shape({
    props: PropTypes.shape({
      carrousel: PropTypes.object,
      cover: PropTypes.object,
    }),
  }),
  lang: PropTypes.string,
  mock: PropTypes.bool,
  url: PropTypes.string,
};

export default InternalPageSimpleLayoutNew;
